import * as React from 'react';
import { Li } from '../list/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
var propTypes = {};
var propKeysToRemove = Object.keys(propTypes);
var AnchorBarListItem = renderWithRef('AnchorBarListItem', propTypes, function (props, ref) {
  var classNames = new Set(['swan-anchor-bar-list-item']);
  var children = props.children;
  return /*#__PURE__*/React.createElement(RenderComp, {
    root: Li,
    forwardedRef: ref,
    propKeysToRemove: propKeysToRemove,
    classNames: classNames,
    props: props
  }, children);
});
export { AnchorBarListItem };